import {
    ACTIVITIES,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    SALESORDERS,
    USERS,
    AGENDA,
    TASKS,
} from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';

export const AUTOMATION_TRIGGERS = {
    create: {
        icon: 'addCircle',
        name: 'label_automation_event_is_created',
    },
    update: {
        icon: 'edit',
        name: 'label_automation_event_is_modified',
    },
    delete: {
        icon: 'delete',
        name: 'label_automation_event_is_deleted',
    },
};

export const AUTOMATION_ENTITIES = [
    COMPANIES,
    ACTIVITIES,
    OPPORTUNITIES,
    CONTACTS,
    SALESORDERS,
    USERS,
    AGENDA,
    TASKS,
];

export const CONDITION_OPERATOR_LOCALES = {
    // General
    empty: 'label_automation_operator_no_data',
    not_empty: 'label_automation_operator_with_data',

    // Text
    text_contains: 'label_automation_operator_contains',
    text_not_contains: 'label_automation_operator_no_contains',
    text_equal: 'label_automation_operator_equal_to',
    text_equal_calculated: 'label_automation_operator_equal_to_another_field',
    text_not_equal: 'label_automation_operator_no_equal_to',
    text_not_equal_calculated: 'label_automation_operator_different_from_another_field',

    // bools
    bool_equal: 'label_automation_operator_equal_to',
    bool_not_equal: 'label_automation_operator_no_equal_to',
    bool_equal_calculated: 'label_automation_operator_equal_to_another_field',
    bool_not_equal_calculated: 'label_automation_operator_different_from_another_field',

    // numbers
    number_equal: 'label_automation_operator_equal_to',
    number_not_equal: 'label_automation_operator_no_equal_to',
    number_greater_than: 'label_automation_operator_greater_than',
    number_greater_equal_than: 'label_automation_operator_greater_equal_than',
    number_less_than: 'label_automation_operator_less_than',
    number_less_equal_than: 'label_automation_operator_less_equal_than',
    number_between: 'label_automation_operator_inside_range',
    number_not_between: 'label_automation_operator_not_inside_range',
    number_equal_calculated: 'label_automation_operator_equal_to_another_field',
    number_not_equal_calculated: 'label_automation_operator_different_from_another_field',

    // dates
    datetime_today: 'common_today',
    datetime_yesterday: 'common_yesterday',
    datetime_tomorrow: 'common_tomorrow',
    datetime_this_week: 'common_this_week',
    datetime_last_week: 'common_last_week',
    datetime_next_week: 'common_next_week',
    datetime_this_month: 'common_this_month',
    datetime_last_month: 'common_last_month',
    datetime_next_month: 'common_next_month',
    datetime_this_quarter: 'common_this_quarter',
    datetime_last_quarter: 'common_last_quarter',
    datetime_next_quarter: 'common_next_quarter',
    datetime_this_year: 'common_this_year',
    datetime_last_year: 'common_last_year',
    datetime_next_year: 'common_next_year',
    datetime_before: 'label_automation_operator_before_than',
    datetime_after: 'label_automation_operator_after_than',
    datetime_on_or_before: 'label_automation_operator_on_or_before_than',
    datetime_on_or_after: 'label_automation_operator_on_or_after_than',
    datetime_in_range: 'label_automation_operator_inside_range',
    datetime_not_in_range: 'label_automation_operator_not_inside_range',
    datetime_last_n_days: 'label_automation_operator_in_the_last_n_days',
    datetime_next_n_days: 'label_automation_operator_in_the_next_n_days',
    datetime_equal_calculated: 'label_automation_operator_equal_to_another_field',
    datetime_not_equal_calculated: 'label_automation_operator_different_from_another_field',
    datetime_day_of_week: 'label_automation_operator_select_day_of_week',
    datetime_month: 'label_automation_operator_select_month',
    datetime_this_weekend: 'common_this_week',

    // list
    list_contains: 'label_automation_operator_contains',
    list_not_contains: 'label_automation_operator_does_not_contain',
    list_equal_calculated: 'label_automation_operator_equal_to_another_field',
    list_not_equal_calculated: 'label_automation_operator_different_from_another_field',

    // multilist
    multilist_contains: 'label_automation_operator_contains',
    multilist_not_contains: 'label_automation_operator_multilist_not_contains',
    multilist_contains_any: 'label_automation_operator_contains_all_values',
    multilist_not_contains_any: 'label_automation_operator_does_not_contains_all_values',
    multilist_equal_calculated: 'label_automation_operator_equal_to_another_field',
    multilist_not_equal_calculated: 'label_automation_operator_different_from_another_field',
};

export const CONDITION_TYPE_DEFAULTS = {
    text: 'text_contains',
    int: 'number_equal',
    decimal: 'number_equal',
    currency: 'number_equal',
    percentage: 'number_equal',
    bit: 'bool_equal',
    list: 'list_contains',
    multivalue: 'multilist_contains',
    datetime: 'not_empty',
};

export const CONDITION_TYPE_NO_INPUT = [
    'empty',
    'not_empty',
    'datetime_today',
    'datetime_yesterday',
    'datetime_tomorrow',
    'datetime_this_weekend',
    'datetime_last_week',
    'datetime_next_week',
    'datetime_this_month',
    'datetime_last_month',
    'datetime_next_month',
    'datetime_this_quarter',
    'datetime_last_quarter',
    'datetime_next_quarter',
    'datetime_this_year',
    'datetime_last_year',
    'datetime_next_year',
];

export const CONDITION_BOOL_LOGIC_LOCALES = {
    and: 'cfm_label_condition_and',
    or: 'cfm_label_condition_or',
};

export const ACTION_OPERATORS = {
    nullable: 'label_automation_operator_equal_to_null',
    calculated_boolean: 'label_automation_operator_equal_to_another_field',
    specific_boolean: 'label_automation_operator_specif_value',
    calculated_datetime: 'label_automation_operator_same_value',
    specific_datetime: 'label_automation_operator_specif_value',
    calculated_calculator_int: 'label_automation_operator_calculated_value',
    calculated_calculator_float: 'label_automation_operator_calculated_value',
    calculated_string: 'label_automation_operator_calculated_value',
    specific_single_list: 'label_automation_operator_specif_value',
    specific_multi_list: 'label_automation_operator_specif_value',
    calculated_single_list: 'label_automation_operator_equal_to_another_field',
    calculated_multi_list: 'label_automation_operator_equal_to_another_field',
    days_after_datetime: 'label_automation_operator_days_after_datetime',
    week_after_datetime: 'label_automation_operator_week_after_datetime',
    month_after_datetime: 'label_automation_operator_month_after_datetime',
    next_day_week_datetime: 'label_automation_operator_next_day_week_datetime',
};

export const ACTION_OPERATORS_DEFAULTS = {
    bit: 'specific_boolean',
    currency: 'calculated_calculator_float',
    datetime: 'calculated_datetime',
    decimal: 'calculated_calculator_float',
    int: 'calculated_calculator_int',
    list: 'specific_single_list',
    multivalue: 'specific_multi_list',
    percentage: 'calculated_calculator_float',
    text: 'calculated_string',
};

export const ACTION_OPERATORS_NO_INPUT = ['nullable'];

export const ACTION_ICONS = {
    update_entity_related: 'edit',
    create_entity: 'addCircle',
};

export function findNodeByType(node, id) {
    if (node.id === id) return node;
    if (Array.isArray(node.next)) {
        for (const child of node.next) {
            const result = findNodeByType(child, id);
            if (result) return result;
        }
    }

    return null;
}

/**
 * Path from the scene root to `targetId`, using dot segments like `next.0.next.1`.
 * Empty string when `targetId` is the scene root node id.
 */
export function findSceneRelativePathByNodeId(obj, targetId, currentPath = '') {
    if (obj.id === targetId) {
        return currentPath;
    }
    if (Array.isArray(obj.next)) {
        for (let i = 0; i < obj.next.length; i++) {
            const childPath = currentPath ? `${currentPath}.next.${i}` : `next.${i}`;
            const result = findSceneRelativePathByNodeId(obj.next[i], targetId, childPath);
            if (result !== null && result !== undefined) return result;
        }
    }
    return null;
}

/** Dot path to the `next` array where a new sibling of the node at `sceneRelativePath` belongs. */
export function getSceneNextDotPathForSiblingBranch(sceneRelativePath) {
    const parentPath =
        sceneRelativePath == null || sceneRelativePath === ''
            ? ''
            : String(sceneRelativePath).replace(/\.next\.\d+$/, '');
    return parentPath ? `scene.${parentPath}.next` : 'scene.next';
}

/** Direct parent node of `childId` in the automation scene tree, or null if none. */
export function findParentAutomationNode(root, childId) {
    if (root.id === childId) return null;
    const walk = (node) => {
        if (!Array.isArray(node.next)) return null;
        for (const child of node.next) {
            if (child.id === childId) return node;
            const found = walk(child);
            if (found) return found;
        }
        return null;
    };
    return walk(root);
}

export function buildPathTree(obj, path) {
    if (!obj || !path) return null;

    const pathParts = path.split('.');
    let current = obj;
    const nodePath = [obj];

    for (let i = 0; i < pathParts.length; i++) {
        const part = pathParts[i];

        if (part === 'next' && i + 1 < pathParts.length) {
            const index = parseInt(pathParts[i + 1], 10);
            if (Array.isArray(current.next) && current.next[index]) {
                current = current.next[index];
                nodePath.push(current);
                i++;
            } else {
                return null;
            }
        } else if (current[part] !== undefined) {
            current = current[part];
            if (typeof current === 'object' && current !== null && current.id) {
                nodePath.push(current);
            }
        } else {
            return null;
        }
    }

    function buildMinimalTree(nodes, index = 0) {
        if (index >= nodes.length) return null;

        const currentNode = { ...nodes[index] };

        // Remove all next branches to avoid unwanted branches
        delete currentNode.next;

        if (index === 0) {
            // First node has scene instead of next
            if (index < nodes.length - 1) {
                const nextNode = buildMinimalTree(nodes, index + 1);
                currentNode.scene = nextNode || {};
            } else {
                currentNode.scene = {};
            }
        } else {
            if (index < nodes.length - 1) {
                const nextNode = buildMinimalTree(nodes, index + 1);
                currentNode.next = nextNode ? [nextNode] : [];
            } else {
                currentNode.next = [];
            }
        }

        return currentNode;
    }

    return buildMinimalTree(nodePath);
}

export const getDayWeekOptions = () => {
    return [
        {
            label: getLiteral('common_monday'),
            value: 1,
        },
        {
            label: getLiteral('common_tuesday'),
            value: 2,
        },
        {
            label: getLiteral('common_wednesday'),
            value: 3,
        },
        {
            label: getLiteral('common_thursday'),
            value: 4,
        },
        {
            label: getLiteral('common_friday'),
            value: 5,
        },
        {
            label: getLiteral('common_saturday'),
            value: 6,
        },
        {
            label: getLiteral('common_sunday'),
            value: 0,
        },
    ];
};

export const getMonthOptions = () => {
    return [
        {
            label: getLiteral('common_january'),
            value: 1,
        },
        {
            label: getLiteral('common_february'),
            value: 2,
        },
        {
            label: getLiteral('common_march'),
            value: 3,
        },
        {
            label: getLiteral('common_april'),
            value: 4,
        },
        {
            label: getLiteral('common_may'),
            value: 5,
        },
        {
            label: getLiteral('common_june'),
            value: 6,
        },
        {
            label: getLiteral('common_july'),
            value: 7,
        },
        {
            label: getLiteral('common_august'),
            value: 8,
        },
        {
            label: getLiteral('common_september'),
            value: 9,
        },
        {
            label: getLiteral('common_october'),
            value: 10,
        },
        {
            label: getLiteral('common_november'),
            value: 11,
        },
        {
            label: getLiteral('common_december'),
            value: 12,
        },
    ];
};

let BOX_COUNT = {
    conditions: 0,
    action: 0,
};

export const initBoxCount = (conditions = 0, action = 0) => {
    BOX_COUNT = {
        conditions,
        action,
    };
};

export const getBoxCount = (type) => {
    return BOX_COUNT[type];
};

export const getNextBoxCount = (type) => {
    BOX_COUNT[type]++;
    return BOX_COUNT[type];
};

export const recalculateNodePositions = (rootNode) => {
    if (!rootNode) return;

    const positionCounters = {
        conditions: 0,
        action: 0,
    };

    const recalculateNode = (node) => {
        if (!node) return;

        if (node.type !== 'trigger' && node.type in positionCounters) {
            positionCounters[node.type]++;
            node.position = positionCounters[node.type];
        }

        if (node.next && Array.isArray(node.next)) {
            node.next.forEach((nextNode) => {
                recalculateNode(nextNode);
            });
        }
    };

    recalculateNode(rootNode);

    BOX_COUNT.conditions = positionCounters.conditions;
    BOX_COUNT.action = positionCounters.action;
};

export const TEMPLATE_ICONS = {
    accounts_create: {
        firstIcon: 'accounts',
        secondIcon: 'addCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    accounts_update: {
        firstIcon: 'accounts',
        secondIcon: 'edit',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    accounts_stage: {
        firstIcon: 'accountsStatus',
    },
    accounts_won: {
        firstIcon: 'accounts',
        secondIcon: 'thumbUp',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    accounts_lost: {
        firstIcon: 'accounts',
        secondIcon: 'thumbDown',
        secondColor: (theme) => theme.colors.semantic.negative500,
    },
    accounts_delete: {
        firstIcon: 'accounts',
        secondIcon: 'removeCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    tasks_create: {
        firstIcon: 'tasks',
        secondIcon: 'addCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    events_create: {
        firstIcon: 'calendar',
        secondIcon: 'addCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    opportunities_create: {
        firstIcon: 'opportunities',
        secondIcon: 'addCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    opportunities_delete: {
        firstIcon: 'opportunities',
        secondIcon: 'removeCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    opportunities_stage: {
        firstIcon: 'opportunitiesStatus',
    },
    opportunities_update: {
        firstIcon: 'opportunities',
        secondIcon: 'edit',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    opportunities_won: {
        firstIcon: 'opportunities',
        secondIcon: 'thumbUp',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    opportunities_lost: {
        firstIcon: 'opportunities',
        secondIcon: 'thumbDown',
        secondColor: (theme) => theme.colors.semantic.negative500,
    },
    activities_create: {
        firstIcon: 'activities',
        secondIcon: 'addCircle',
        secondColor: (theme) => theme.colors.actionMajor[500],
    },
    salesorders_stage: {
        firstIcon: 'salesordersStatus',
    },
};

export const shouldShowEntity = (operator) => {
    return [
        'text_equal_calculated',
        'text_not_equal_calculated',
        'bool_equal_calculated',
        'bool_not_equal_calculated',
        'number_equal_calculated',
        'number_not_equal_calculated',
        'list_equal_calculated',
        'list_not_equal_calculated',
        'list_contains',
        'list_not_contains',
        'multilist_contains',
        'multilist_not_contains',
        'multilist_contains_any',
        'multilist_not_contains_any',
        'multilist_equal_calculated',
        'multilist_not_equal_calculated',
        'datetime_equal_calculated',
        'datetime_not_equal_calculated',
    ].includes(operator);
};
